'use strict';

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target) {
    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
    $veil.append(`
        <div class="spinner">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
            <path class="cls-2" d="M84.65,50.81c.06-2.88,1.57-5.65,4.23-7.21,2.88-1.65,6.28-1.48,8.86.18,0,0,49.71,28.78,49.78,28.84l.07.03c2.45,1.52,4.08,4.23,4.08,7.39s-1.87,6.15-4.56,7.61c0,0-49.67,28.74-49.81,28.84l-.07.04c-2.49,1.37-5.68,1.42-8.35-.14-2.87-1.64-4.4-4.7-4.23-7.82v-57.77Z"/>
            <path class="cls-3" d="M8.33,8.37c.06-2.87,1.6-5.64,4.31-7.24,2.87-1.63,6.23-1.46,8.91.21,0,0,49.64,28.76,49.74,28.81l.04.05c2.43,1.51,4.11,4.23,4.11,7.35,0,3.32-1.88,6.18-4.63,7.63,0,0-49.67,28.81-49.74,28.86l-.06.03c-2.54,1.38-5.73,1.45-8.37-.1-2.87-1.69-4.44-4.75-4.29-7.83l-.02-23.58V8.37Z"/>
            <path class="cls-1" d="M8.33,93.27c.06-2.92,1.6-5.68,4.31-7.21,2.87-1.66,6.23-1.5,8.91.17,0,0,49.64,28.78,49.74,28.85h.04c2.43,1.52,4.11,4.27,4.11,7.35,0,3.32-1.88,6.2-4.63,7.66,0,0-49.67,28.77-49.74,28.85l-.06.03c-2.54,1.38-5.73,1.4-8.37-.15-2.87-1.62-4.44-4.71-4.29-7.8l-.02-23.58v-34.17Z"/>
            </svg>
        </div>`);
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled');
        }
    }

    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

// element level spinner:
$.fn.spinner = function () {
    var $element = $(this);
    var Fn = function () {
        this.start = function () {
            if ($element.length) {
                addSpinner($element);
            }
        };
        this.stop = function () {
            if ($element.length) {
                var $veil = $('.veil');
                removeSpinner($veil);
            }
        };
    };
    return new Fn();
};

// page-level spinner:
$.spinner = function () {
    var Fn = function () {
        this.start = function () {
            addSpinner($('body'));
        };
        this.stop = function () {
            removeSpinner($('.veil'));
        };
    };
    return new Fn();
};
